<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span><strong>Copyright © 2015-2016 Bitwave Inc</strong> All rights reserved. Powered by ZioTes</span>
<!--          <span>COPYRIGHT &copy;</span>-->
<!--          <span>{{ new Date().getFullYear() }} </span>-->
<!--          <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">Pixinvent</a>-->
<!--          <span class="hidden sm:inline-block">, All rights Reserved</span>-->
        </p>
        <span class="md:flex hidden items-center">
            <span>Version 1.0</span>
<!--            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />-->
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
